<div
  class="limit-bar-common limit-bar-container"
  [ngClass]="{
    'bar-loading': isLoading,
    'primary-colors': !isLoading && this.color === 'primary',
    'warn-colors': !isLoading && this.color === 'warn',
    'error-colors': !isLoading && this.color === 'error',
    'success-colors': !isLoading && this.color === 'success',
  }"
>
  <div
    class="limit-bar-common limit-bar-progress"
    [class.animate-on-enter]="animateOnEnter()"
    [style.--glxy-progress]="progress + '%'"
  ></div>
</div>
